function orderSlotProviders (games = []) {
  const result = games.slice()
  const isSlotCode = code => game => game.groupCode === 'slot' && String(game.code).trim() === code
  const rrg = result.findIndex(isSlotCode('134'))
  if (rrg < 0 || !result.some(isSlotCode('101'))) return result
  const [provider] = result.splice(rrg, 1)
  result.splice(result.findIndex(isSlotCode('101')) + 1, 0, provider)
  return result
}

module.exports = { orderSlotProviders }
